import { Box2d, Editor } from '@tldraw/tldraw'
import { FrameShape } from 'components/VisualStudioPlayground/Shapes/FrameShape/Types'
import { getOrderedFrames } from 'components/VisualStudioPlayground/Shapes/FrameShape/helpers'

export const getInitialSceneBounds = (editor: Editor, frame: FrameShape, padding: { top: number; bottom: number }) => {
  let bounds = editor.getShapePageBounds(frame)
  if (!bounds) {
    return undefined
  }
  if (frame.props.position !== 1) {
    return bounds
  }

  const { x, y, width, height } = bounds
  let paddingBottom = padding.bottom
  let paddingTop = padding.top
  if (getOrderedFrames(editor).length > 1) {
    paddingBottom += 150
  }
  const result = new Box2d(x, y - paddingTop, width, height + paddingTop + paddingBottom)
  return result
}

interface ZoomToInitialBoundsProps {
  editor: Editor
  frame: FrameShape
  padding: { top: number; bottom: number }
  animate?: boolean
}
export const zoomToInitialBounds = ({ editor, frame, padding, animate = false }: ZoomToInitialBoundsProps) => {
  const captionPadding = getCaptionPadding()
  padding.top += captionPadding.top
  padding.bottom += captionPadding.bottom

  const bounds = getInitialSceneBounds(editor, frame, padding)

  if (bounds) {
    const viewportScreenBounds = editor.getViewportScreenBounds()

    // Calculate the height that can fit in the mobile viewport
    const maxHeightZoom = viewportScreenBounds.height / bounds.height

    // Calculate the zoom so that the frame is max 600 wide
    const maxWidthZoom = 600 / bounds.width
    const zoom = Math.min(maxHeightZoom, maxWidthZoom, 1)
    const animation = animate ? { duration: 300, easing: (t: number) => t * (2 - t) } : undefined
    editor.zoomToBounds(bounds, zoom, animation)
  } else {
    editor.zoomToFit()
  }
}

export const getCaptionPadding = () => {
  const padding = { top: 0, bottom: 0 }
  const captionEl = document.querySelector('#design-caption') as HTMLElement

  if (captionEl) {
    const height = captionEl.offsetHeight
    const position = captionEl?.dataset?.captionPosition

    if (position === 'above') {
      padding.top = height
    }
    if (position === 'below') {
      padding.bottom = height
    }
  }

  return padding
}
